export default {
    title: "Importar pedidos",
    upload_label: "Por favor envie um arquivo .csv",
    help_center: "Ver central de ajuda",
    select_branch: "Por favor selecione a unidade",
    one_row_per_product: "O CSV contem uma linha por produto?",
    loading_message: "Enviando dados, isso pode levar alguns minutos...",
    file_size_error: "O arquivo deve ter no maximo {0}MB",
    csv_error: "Ocorreu um erro ao ler o CSV, confira se o arquivo e valido",
    order_id_required: "Selecione a coluna do Id do Pedido para continuar. Ela é obrigatória e identifica cada pedido.",
    include_time: "Contem a hora tambem",
    format: "Formato",
    decimal_separator: "Separador Decimal",
    full_name: "Contem o nome completo",
    default_prefix: "DDD Padrao",
    products: "Produtos",
    brand: "Marca",
    category: "Categoria",
    price: "Preco",
    cost: "Custo",
    summary: {
        new_clients: "Novos clientes",
        new_orders: "Novos pedidos",
        updated_status: "Atualizacoes de status",
        already_imported: "Pedidos que ja existiam e nao foram importados",
        failed_rows: "Linhas que falharam:",
    },
    download_csv: "Baixar CSV",
    cancel: "Cancelar",
    next: "Proximo",
    back: "Voltar",
    import: "Importar",
    close: "Fechar",
    queued_message: "Importação enviada! Ela será processada em segundo plano.",
    queued_link: "Acompanhar no histórico de importações",
    open_button: "Importar pedidos",
    columns: {
        external_id: "Id do Pedido",
        client_external_id: "Id do cliente",
        date: "Data",
        time: "Hora",
        value: "Valor",
        first_name: "Nome",
        last_name: "Sobrenome",
        whatsapp: "Telefone",
        email: "E-mail",
        birthdate: "Data de Nascimento",
        external_status: "Status do Pedido",
        status: "Status do Kevi",
        product_external_id: "Id do Produto",
        product_name: "Nome do Produto",
        category: "Categoria do Produto",
        brand: "Marca do Produto",
        price: "Preco do Produto",
        cost: "Custo do Produto",
        quantity: "Quantidade do Produto",
    },
};
